import React from 'react';
import Toggle from 'material-ui/Toggle';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import muiTheme from '../../utils/muiTheme'

const styles = {
  block: {
    maxWidth: 250,
  },
  toggle: {
    marginBottom: 16,
  },
  thumbOff: {
    backgroundColor: 'white',
  },
  trackOff: {
    backgroundColor: '#c5c5c5',
  },
  thumbSwitched: {
    backgroundColor: 'white',
  },
  trackSwitched: {
    backgroundColor: '#31b59f',
  },
};

const ToggleSwitch = (props) => (

  <div className="toggle-switch" style={styles.block}>
    <MuiThemeProvider muiTheme={muiTheme}>
      <Toggle
        thumbStyle={styles.thumbOff}
        trackStyle={styles.trackOff}
        thumbSwitchedStyle={styles.thumbSwitched}
        trackSwitchedStyle={styles.trackSwitched}
        defaultToggled={props.defaultToggled}
        onToggle={props.onToggle}
      />
    </MuiThemeProvider>
  </div>
);

export default ToggleSwitch;



// WEBPACK FOOTER //
// ./src/core/components/ToggleSwitch.js